module.exports = __webpack_public_path__ + "../static/img/sigma.3d0ec486.png";